// js/components/body/carouselGroup.js
/* jshint esversion: 6 */
"use strict";
import {
    promiseFetchData,
    getCookie,
} from '../initial/myInitialModules';

import {
    fadeIn,
    fadeOut,
} from '../common/elementEffectsGroup';

export function carouselGroup() {
    console.log("masuk carousel group js...");
    let screenWidth;
    let screenType;
    const laptop = "Laptop";
    const mobile = "Mobile";
    const tablet = "Tablet";
    const divsAjaxHomeEndpointSelector = "div[name='ajax_homepage_endpoint']";
    // const divsAjaxEndpointSelector = "div[name='ajax_endpoint']";
    const divsAjaxHomeEndpoint = document.querySelectorAll(divsAjaxHomeEndpointSelector);
    // const divsAjaxEndpoint = document.querySelectorAll(divsAjaxEndpointSelector);
    if(divsAjaxHomeEndpoint){
        divsAjaxHomeEndpoint.forEach(div => {
            // homeAjaxUrl = div.getAttribute('data-screen-checker-url');
            // csrfData = div.getAttribute('data-csrf');
            screenWidth = div.getAttribute('data-screen-width');
            screenType = div.getAttribute('data-screen-type');
        });
    }

    let NonCellbusinessName;
    let NonCellmember;
    let NonCellpageLayoutIntToken;
    let NonCellcarouselEnpointUrl;
    let CellbusinessName;
    let Cellmember;
    let CellpageLayoutIntToken;
    let CellcarouselEnpointUrl;
    const csrftoken = getCookie('csrftoken');
    const fadeOutMs = 2000;
    const fadeInMs = 2000;
    const divCellParentCarouselSelector = "div[name='cell_parent_carousel']";
    const divCellCarouseEndpointSelector = "div[name='cell_carousel_ajax_endpoint']";
    const divNonCellParentCarouselSelector = "div[name='non_cell_parent_carousel']";
    const divNonCellCarouseEndpointSelector = "div[name='noncell_carousel_ajax_endpoint']";
    const divNonCellParentCarouselElements = document.querySelectorAll(divNonCellParentCarouselSelector);
    const divNonCellCarouseEndpointElements = document.querySelectorAll(divNonCellCarouseEndpointSelector);
    const divCellParentCarouselElements = document.querySelectorAll(divCellParentCarouselSelector);
    const divCellCarouseEndpointElements = document.querySelectorAll(divCellCarouseEndpointSelector);
    if (divNonCellCarouseEndpointElements) {
        divNonCellCarouseEndpointElements.forEach(div => {
            NonCellcarouselEnpointUrl = div.getAttribute('data-url');
        });
    }
    if (divNonCellParentCarouselElements) {
        divNonCellParentCarouselElements.forEach(div => {
            NonCellbusinessName = div.getAttribute('data-business-id');
            NonCellmember = div.getAttribute('data-NonCellmember-id');
            NonCellpageLayoutIntToken = div.getAttribute('data-page-id');
        });
    }

    if (divCellCarouseEndpointElements) {
        divCellCarouseEndpointElements.forEach(div => {
            CellcarouselEnpointUrl = div.getAttribute('data-url');
        });
    }
    if (divCellParentCarouselElements) {
        console.log("masuk if (divCellParentCarouselElements) { carousel group js...");
        divCellParentCarouselElements.forEach(div => {
            console.log("masuk divCellParentCarouselElements.forEach(div => {carousel group js...");
            CellbusinessName = div.getAttribute('data-business-id');
            Cellmember = div.getAttribute('data-NonCellmember-id');
            CellpageLayoutIntToken = div.getAttribute('data-page-id');
            // div.style.display = 'block';
            // div.style.setProperty('data-test', 'block', 'important');
            // div.style.cssText = 'data-ri: test !important;';

        });
    }

    if(screenType === laptop || screenType === tablet){
        console.log("masuk if(screenType === laptop || screenType === tablet){");
        console.log("value of NonCellcarouselEnpointUrl : ");
        console.log(NonCellcarouselEnpointUrl);
        if(NonCellcarouselEnpointUrl){
            const dataSend = {
                business_name: NonCellbusinessName,
                member: NonCellmember,
                page_layout_int_token: NonCellpageLayoutIntToken,
            };
            promiseFetchData(NonCellcarouselEnpointUrl, {
                timeout: 5000,
                method: 'POST', // or 'GET', 'PUT', etc.
                headers: {
                    'Content-Type': 'application/json', // Specify the content type if sending JSON data
                    'X-CSRFToken': csrftoken, // Include CSRF token for POST requests
                    'Cache-Control': 'no-cache'
                },
                body: JSON.stringify(dataSend)
            })
                .then(data => {
                    console.log("masuk.then(data => {");
                    // Process the response data
                    console.log(data);
                    const dataContent = data;
                    console.log("isi dataContent in carouselGroup: ");
                    console.log(dataContent);
                    const dataStatus = data.status;
                    console.log("isi dataStatus : ");
                    console.log(dataStatus);
                    if (dataStatus === 200) {
                        console.log("masuk if (dataStatus === 200)");
                        divNonCellParentCarouselElements.forEach(div => {
                            console.log("isi div divNonCellParentCarouselElements in carouselGroup: ");
                            div.style.display = '';
                            // fadeOut(div, fadeOutMs);
                            const htmlContent = dataContent.html_content;
                            div.innerHTML = htmlContent;
                            fadeIn(div, fadeInMs);

                        });

                    } else {
                        console.log("masuk if (status === fail) {");
                        const errorMessage = data.message;
                    }
                })
                .catch(error => {
                    // Handle any errors that occurred during the fetch
                    console.error('Fetch error:', error);
                });
        }
    }else if(screenType === mobile){
        if(CellcarouselEnpointUrl) {
            const dataSend = {
                business_name: CellbusinessName,
                member: Cellmember,
                page_layout_int_token: CellpageLayoutIntToken,
            };
            promiseFetchData(CellcarouselEnpointUrl, {
                timeout: 5000,
                method: 'POST', // or 'GET', 'PUT', etc.
                headers: {
                    'Content-Type': 'application/json', // Specify the content type if sending JSON data
                    'X-CSRFToken': csrftoken, // Include CSRF token for POST requests
                    'Cache-Control': 'no-cache'
                },
                body: JSON.stringify(dataSend)
            })
                .then(data => {
                    console.log("masuk.then(data => {");
                    // Process the response data
                    console.log(data);
                    const dataContent = data;
                    console.log("isi dataContent in carouselGroup: ");
                    console.log(dataContent);
                    const dataStatus = data.status;
                    console.log("isi dataStatus : ");
                    console.log(dataStatus);
                    if (dataStatus === 200) {
                        console.log("masuk if (dataStatus === 200)");
                        divCellParentCarouselElements.forEach(div => {
                            console.log("isi div divNonCellParentCarouselElements in carouselGroup: ");

                            // fadeOut(div, fadeOutMs);
                            // div.style.display = 'block';
                            // div.style.setProperty('display', 'block', 'important');
                            const htmlContent = dataContent.html_content;
                            div.innerHTML = htmlContent;
                            fadeIn(div, fadeInMs);
                            // div.style.setProperty('display', 'block', 'important');
                        });

                    } else {
                        console.log("masuk if (status === fail) {");
                        const errorMessage = data.message;
                    }
                })
                .catch(error => {
                    // Handle any errors that occurred during the fetch
                    console.error('Fetch error:', error);
                });
        }
    }
}

